
import BaseInput from '@/components/BaseInput.vue'
import VariantCheckbox from '@/components/VariantCheckbox.vue'
import BaseButton from '@/components/BaseButton.vue'
import { useQuizStore } from '@/store/quiz'
import { QuestionType } from '@/utils/types'
import { computed, defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'begin-quiz',
  components: { BaseInput, VariantCheckbox, BaseButton },
  setup() {
    const store = useQuizStore()
    const router = useRouter()
    const answer = ref('')
    const checked = ref<number[]>([])

    const question = computed(() => store.questions[store.questionIndex])

    function updateCheckbox(id: number) {
      if (question.value.type === 'SINGLE') {
        checked.value = [id]
      } else if (checked.value.includes(id)) {
        checked.value = checked.value.filter((el) => el !== id)
      } else {
        checked.value.push(id)
      }
    }

    function clearInput() {
      answer.value = ''
      checked.value = []
    }

    function nextQuestion() {
      if (question.value.type === QuestionType.WRITTEN) {
        store.nextQuestion(answer.value)
      } else if (question.value.type === QuestionType.SINGLE) {
        store.nextQuestion(checked.value[0])
      } else {
        store.nextQuestion(checked.value)
      }

      if (store.questions.length - 1 === store.questionIndex) {
        store.answerAll()
        router.push('/end-quiz')
      } else {
        clearInput()
        store.questionIndex += 1
      }
    }

    return {
      store,
      question,
      answer,
      checked,
      updateCheckbox,
      nextQuestion,
    }
  },
})
